export const kioskSettingsKeys = {
    all: ['kioskSettings'] as const,
    detail: (centerId: string) => [...kioskSettingsKeys.all, 'detail', centerId] as const,
};
